import { css } from 'styled-components';

const icons = css`
    font-family: ${props => props.theme.font.face.icon} !important;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`;

export default icons;
